import React from 'react';
import { Minus, Plus } from 'lucide-react';

type CreditAdjustInputProps = {
  id: string;
  label: string;
  value: number;
  onChange: (value: number) => void;
  placeholder?: string;
  step?: number;
};

/**
 * Campo numérico com botões − / + para mobile e desktop.
 * Navegadores mobile (iOS Safari, Android Chrome) não exibem setas nativas em type="number".
 */
export const CreditAdjustInput: React.FC<CreditAdjustInputProps> = ({
  id,
  label,
  value,
  onChange,
  placeholder,
  step = 1,
}) => {
  const handleDelta = (delta: number) => {
    const next = value + delta;
    onChange(Number.isFinite(next) ? next : 0);
  };

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const raw = e.target.value;
    if (raw === '' || raw === '-') {
      onChange(0);
      return;
    }
    onChange(Number(raw));
  };

  return (
    <div>
      <label htmlFor={id} className="block text-sm font-medium text-gray-700 mb-1">
        {label}
      </label>
      <div className="flex items-stretch gap-2">
        <button
          type="button"
          onClick={() => handleDelta(-step)}
          aria-label={`Diminuir ${label}`}
          className="flex-shrink-0 min-w-[44px] min-h-[44px] flex items-center justify-center rounded-lg border border-gray-300 bg-gray-50 text-gray-700 hover:bg-gray-100 active:bg-gray-200 transition-colors touch-manipulation"
        >
          <Minus className="w-5 h-5" aria-hidden />
        </button>
        <input
          id={id}
          type="number"
          inputMode="decimal"
          step={step}
          value={Number.isFinite(value) ? value : 0}
          onChange={handleInputChange}
          placeholder={placeholder}
          className="credit-adjust-input flex-1 min-w-0 px-3 py-2 border border-gray-300 rounded-lg text-center focus:ring-2 focus:ring-blue-500 focus:border-transparent"
        />
        <button
          type="button"
          onClick={() => handleDelta(step)}
          aria-label={`Aumentar ${label}`}
          className="flex-shrink-0 min-w-[44px] min-h-[44px] flex items-center justify-center rounded-lg border border-gray-300 bg-gray-50 text-gray-700 hover:bg-gray-100 active:bg-gray-200 transition-colors touch-manipulation"
        >
          <Plus className="w-5 h-5" aria-hidden />
        </button>
      </div>
    </div>
  );
};
